import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Eyebrow } from './Eyebrow';
export function Faqs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="bg-night py-16 sm:py-24" data-id="element-99" data-mp="355wlzbxedpkz">
      <div className="mx-auto grid max-w-shell gap-8 px-5 sm:px-6 lg:grid-cols-[minmax(0,22rem)_minmax(0,1fr)] lg:gap-20" data-id="element-100" data-mp="357zmwr03934h">
        <div data-id="element-101" data-mp="3f42pfxyur3ry">
          <Eyebrow tone="muted" data-id="element-102" data-mp="3f3je503pjdmw">Najczęściej zadawane pytania</Eyebrow>
          <h2 id="faq-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-103" data-mp="3k3fjb2o55b41">
            Zanim <span className="text-amber" data-id="element-104" data-mp="3o5iyo2dxkzul">zdecydujesz</span>
          </h2>
        </div>
        <div className="space-y-3" data-id="element-105" data-mp="1ppedtyy35puz">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={`rounded-xl border bg-night-800 transition-colors duration-150 ease-out ${isOpen ? 'border-amber/50' : 'border-night-600'}`} data-id="element-106" data-mp="1trrggehjd7nj" data-mpi={index}>
                <h3 data-id="element-107" data-mp="27lfpwd55czcb">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left sm:px-6" data-id="element-108" data-mp="27mqv8he8qf5j">
                    <span className="text-base font-semibold leading-snug text-cream sm:text-lg" data-id="element-109" data-mp="2qc6wj6xr2bn0">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-amber transition-transform duration-150 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-110" data-mp="2lcki4u66qpcm" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-111" data-mp="1wdrs7vgpfyi">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-112" data-mp="5zacc44kbm53">
                      <p className="px-5 pb-6 text-sm leading-relaxed text-cream-soft sm:px-6 sm:text-base" data-id="element-113" data-mp="3j8pvrjf99n4r">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}